import React, { useContext, useEffect, useRef, useState } from 'react'
import { Container, List, makeStyles, ListItem, Button, Select, MenuItem, FormControl } from "@material-ui/core";
import { _useToasts } from '../../common/_useToasts'
import DeleteIcon from '@material-ui/icons/Delete';
import ColorPicker from "material-ui-color-picker";
import JoditEditor from "jodit-react";
import TextEditorConfig from '../../helpers/TextEditor';
import { CLASSNAME_M_B, CLASSNAME_M_L, CLASSNAME_M_R, CLASSNAME_M_T, CLASSNAME_P_B, CLASSNAME_P_L, CLASSNAME_P_R, CLASSNAME_P_T } from '../../constant/bannerItems';
import useForm from '../banner/customHooks';
import { THEME_URL, UPLOADIMAGE, X_TENANT_ID } from '../../common/ActionUrl';
import axios from 'axios';
import Loader from '../../common/Loader';
import { AuthContext } from '../../common/Auth';
import { USERTYPES } from '../../constant/userType';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 600,
        backgroundColor: theme.palette.background.paper,
    },
    createUser: {
        width: '100%',
        maxWidth: 800,
    },
    textField: {
        width: '100%',
    }
}));

const BrandLogoForm = ({ handleClose, brandLogoId }) => {
    const { _addToast } = _useToasts();
    const classes = useStyles();
    const { user, userType, getThemeSettings } = useContext(AuthContext)
    const adminUserId = user?.userId
    const [isLoading, setIsLoading] = useState(false);
    const [tempBgImage, setTempBgImage] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const editor = useRef(null)
    const [temp, setTemp] = useState("")
    const [brandLogoSettingsData, setBrandLogoSettingsData] = useState({});

    const [sectionTitle, setSectionTitle] = useState("")
    const [sectionSubTitle, setSectionSubTitle] = useState("")

    const { inputs, handleSubmit, handleInputChange, handleNumberInputChange, handleColorPicker, resetColor, resetForm, handleCheckboxInputChange, errors } = useForm({
        bgColor: "",
        bgImage: "",
        sectionTitle: "",
        sectionSubTitle: "",
        marginTop: "",
        marginBottom: "",
        marginLeft: "", marginRight: "", paddingRight: "", paddingLeft: "", paddingTop: "", paddingBottom: "", fullSection: false,
    }, "", brandLogoCallback);

    async function brandLogoCallback() {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        let insertData = {
            "values": {
                "bgImage": tempBgImage ? tempBgImage : "",
                "bgColor": inputs.bgColor ? inputs.bgColor : "",
                "sectionTitle": sectionTitle,
                "sectionSubTitle": sectionSubTitle,
                "paddingTop": inputs.paddingTop,
                "paddingBottom": inputs.paddingBottom,
                "paddingRight": inputs.paddingRight,
                "paddingLeft": inputs.paddingLeft,
                "marginBottom": inputs.marginBottom,
                "marginTop": inputs.marginTop,
                "marginLeft": inputs.marginLeft,
                "marginRight": inputs.marginRight,
                "fullSection": inputs.fullSection,
            },
            "settingsName": "brandLogoSettings",
            userId: adminUserId
        }
        if (brandLogoId) {
            await axios.patch(THEME_URL + brandLogoId, insertData, requestOptions)
                .then(res => {
                    getBrandLogoSetings()
                    setIsLoading(false)
                    if (res.data.error) {

                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        handleClose()
                        getThemeSettings()
                        _addToast("Settings updated successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });

                    }
                }).catch((error, config, code, request, response) => {
                    setIsLoading(false)
                    _addToast('Issues while update settings', {
                        appearance: "error",
                        autoDismiss: true
                    });

                });
        }
    }

    const getBrandLogoSetings = () => {
        setIsLoading(true)
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(THEME_URL, requestOptions)
            .then(res => {
                setIsLoading(false)
                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    res.data.map((items, index) => {
                        if (items.settingsName === "brandLogoSettings") {
                            setBrandLogoSettingsData(items.values[0])
                            setTempBgImage(items.values[0]?.bgImage)
                            setSectionTitle(items.values[0]?.sectionTitle)
                            setSectionSubTitle(items.values[0]?.sectionSubTitle)
                        }
                    })
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }

    useEffect(() => {
        getBrandLogoSetings()
    }, [])

    const [value, setValue] = useState(0);
    useEffect(() => {
        if (Object.keys(brandLogoSettingsData).length > 0) {
            inputs.bgImage = tempBgImage ? tempBgImage : ""
            inputs.bgColor = brandLogoSettingsData.bgColor
            inputs.sectionTitle = brandLogoSettingsData.sectionTitle
            inputs.sectionSubTitle = brandLogoSettingsData.sectionSubTitle
            inputs.marginBottom = brandLogoSettingsData.marginBottom
            inputs.marginTop = brandLogoSettingsData.marginTop
            inputs.marginLeft = brandLogoSettingsData.marginLeft
            inputs.marginRight = brandLogoSettingsData.marginRight
            inputs.fullSection = brandLogoSettingsData.fullSection
            inputs.paddingTop = brandLogoSettingsData.paddingTop
            inputs.paddingBottom = brandLogoSettingsData.paddingBottom
            inputs.paddingRight = brandLogoSettingsData.paddingRight
            inputs.paddingLeft = brandLogoSettingsData.paddingLeft
            setValue(value => value + 1);
        }
    }, [brandLogoSettingsData])

    const setImageFile = (event, type) => {
        setIsLoading(true)
        const photoTarget = event.target.files[0];
        if (photoTarget && photoTarget.name.match(/\.(jpg|jpeg|png|gif|webp)$/)) {
            setErrorFlag(false)
            const formData = new FormData();
            formData.append("file", photoTarget, photoTarget.name);

            const requestOptions = {
                headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
            };
            axios.post(UPLOADIMAGE, formData, requestOptions)
                .then(res => {
                    setIsLoading(false)
                    if (res.data.error) {

                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        if (res.data && res.data.Location != "") {
                            if (type === 'bgImage') {
                                setTempBgImage(res.data.Location)
                            }
                        }
                    }
                }).catch((error, config, code, request, response) => {
                    setIsLoading(false)
                    _addToast('Error while Uploded Image!', {
                        appearance: "error",
                        autoDismiss: true
                    });

                });
        } else {
            setErrorFlag(true)
            setIsLoading(false)
            _addToast('Image type not allow', {
                appearance: "error",
                autoDismiss: true
            });
        }
    }

    return (
        <>
            {isLoading && (
                <Loader />
            )}
            {userType !== USERTYPES.USER ?
                <div className="banner-form" style={{ 'minHeight': '50vh' }}>
                    <form className="banner-form-style" onSubmit={handleSubmit}>
                        <div className="col-md-12">
                            <div className="row inputRow">

                                <div className="col-md-6 form-group">
                                    <label>Background Image</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <div className={`r-display  ${classes.textField}`}>
                                        <div >
                                            <input onChange={(e) => setImageFile(e, 'bgImage')}
                                                type="file"
                                                name="bgImage"
                                                accept="image/*"
                                            />
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                                            {tempBgImage && (
                                                <>
                                                    <img height="50px" width="50px" src={tempBgImage}></img>
                                                    <DeleteIcon
                                                        className="text-error"
                                                        title={"Delete"}
                                                        onClick={() => {
                                                            setTempBgImage("")
                                                        }}
                                                        aria-label=""
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 form-group">
                                    <label>Background color</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <div className="row w-100">
                                        <div className="col-lg-4">
                                            <ColorPicker
                                                name="bgColor"
                                                defaultValue="Select Color"
                                                value={inputs?.bgColor}
                                                onChange={color => { handleColorPicker('bgColor', color) }}
                                            />
                                        </div>
                                        <div className="col-lg-3">
                                            <p>{inputs?.bgColor != undefined && (inputs?.bgColor)}</p>
                                        </div>

                                        {inputs?.bgColor != undefined && inputs?.bgColor != "undefined" && inputs?.bgColor != "" && (
                                            <DeleteIcon
                                                className="text-error rowPointer"
                                                title={"Delete"}
                                                onClick={() => {
                                                    resetColor("", 'bgColor')
                                                }}
                                                aria-label=""
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Section Title</label>
                                </div>
                                <div className="col-md-12 form-group">
                                    <JoditEditor
                                        ref={editor}
                                        value={inputs?.sectionTitle}
                                        config={TextEditorConfig}
                                        tabIndex={1}
                                        onChange={(bodyOfEditor) => {
                                            setSectionTitle(bodyOfEditor)
                                            setTemp('0');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row inputRow">
                                <div className="col-md-6 form-group">
                                    <label>Section Sub Title</label>
                                </div>
                                <div className="col-md-12 form-group">
                                    <JoditEditor
                                        ref={editor}
                                        value={inputs?.sectionSubTitle}
                                        config={TextEditorConfig}
                                        tabIndex={1}
                                        onChange={(bodyOfEditor) => {
                                            setSectionSubTitle(bodyOfEditor)
                                            setTemp('0');
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Margin top</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.marginTop}
                                            onChange={handleInputChange}
                                            name="marginTop">
                                            {CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Margin Bottom</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.marginBottom}
                                            onChange={handleInputChange}
                                            name="marginBottom">
                                            {CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Margin Left</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.marginLeft}
                                            onChange={handleInputChange}
                                            name="marginLeft">
                                            {CLASSNAME_M_L && CLASSNAME_M_L.length && Object.keys(CLASSNAME_M_L).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_M_L[data].value}> {CLASSNAME_M_L[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Margin Right</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.marginRight}
                                            onChange={handleInputChange}
                                            name="marginRight">
                                            {CLASSNAME_M_R && CLASSNAME_M_R.length && Object.keys(CLASSNAME_M_R).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_M_R[data].value}> {CLASSNAME_M_R[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_M_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Padding Right</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.paddingRight}
                                            onChange={handleInputChange}
                                            name="paddingRight">
                                            {CLASSNAME_P_R && CLASSNAME_P_R.length && Object.keys(CLASSNAME_P_R).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_P_R[data].value}> {CLASSNAME_P_R[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Padding Left</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.paddingLeft}
                                            onChange={handleInputChange}
                                            name="paddingLeft">
                                            {CLASSNAME_P_L && CLASSNAME_P_L.length && Object.keys(CLASSNAME_P_L).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_P_L[data].value}> {CLASSNAME_P_L[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Padding Top</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.paddingTop}
                                            onChange={handleInputChange}
                                            name="paddingTop">
                                            {CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Padding Bottom</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <FormControl variant="outlined" className="w-100">
                                        <Select labelId="demo-simple-select-outlined-label" value={inputs?.paddingBottom}
                                            onChange={handleInputChange}
                                            name="paddingBottom">
                                            {CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
                                                return <MenuItem value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
                                            })}
                                            {!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label>Full Section</label>
                                </div>
                                <div className="col-md-6 form-group">
                                    <input style={{ width: "24px" }} type="checkbox" className="singleCheckbox" onChange={handleCheckboxInputChange} value={inputs?.fullSection} aria-describedby="fullSection" name="fullSection" checked={inputs?.fullSection ? true : false} />
                                </div>
                            </div>

                        </div>
                        <List>
                            <ListItem>
                                <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                                <Button variant="contained" color="primary" className="bannerbutton" type="submit"> {brandLogoId ? "Update" : "Save"}</Button>
                            </ListItem>
                        </List>

                    </form>
                </div>

                : <h2>You haven't authority for update settings</h2>
            }
        </>
    )
}

export default BrandLogoForm